import React, { FC } from "react";

import { Button, Typography } from "@mui/material";
import DialogActions from "@mui/material/DialogActions";
import DialogTitle from "@mui/material/DialogTitle";

import { CheckCircleIcon } from "@/assets/icons";

import { StyledSuccessDialog } from "./styled";

export type SuccessDialogProps = {
    open: boolean;
    title: string;
    message: string;
    confirmButton: string;
    onClose: () => void;
};

const SuccessDialog: FC<SuccessDialogProps> = ({ open, title, message, confirmButton, onClose }) => {
    return (
        <StyledSuccessDialog classes={{ paper: "dialog-paper" }} open={open} onClose={onClose}>
            <div className="successIcon">
                <CheckCircleIcon />
            </div>
            <DialogTitle classes={{ root: "dialog-title-root" }}>
                <Typography className="successTitle">{title}</Typography>
            </DialogTitle>
            <Typography variant="body1" className="successMessage">
                {message}
            </Typography>
            <DialogActions classes={{ root: "dialog-actions-root" }} style={{ justifyContent: "center" }}>
                <Button fullWidth onClick={onClose} data-testid="confirm-success">
                    {confirmButton}
                </Button>
            </DialogActions>
        </StyledSuccessDialog>
    );
};

export default SuccessDialog;
